"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getButtonUnits = void 0;
var borderRadius_1 = require("./borderRadius");
var fontSizes_1 = require("./fontSizes");
var paddings_1 = require("./paddings");
var getButtonUnits = function (brand) {
    return {
        borderRadius: (0, borderRadius_1.getBorderRadius)(brand),
        fontSizes: (0, fontSizes_1.getButtonFontSize)(brand),
        paddings: (0, paddings_1.getButtonPaddings)(brand),
    };
};
exports.getButtonUnits = getButtonUnits;
